var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditProfileDarkIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.003,
    height: 12.752,
    viewBox: "0 0 17.003 12.752",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "person-lines-fill",
    transform: "translate(0 -24)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_161858",
    "data-name": "Group 161858",
    transform: "translate(0 24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83818",
    "data-name": "Path 83818",
    d: "M6.376,30.376a3.188,3.188,0,1,0-3.188-3.188A3.188,3.188,0,0,0,6.376,30.376ZM1.063,36.752A1.041,1.041,0,0,1,0,35.689c0-1.063,1.063-4.251,6.376-4.251s6.376,3.188,6.376,4.251a1.041,1.041,0,0,1-1.063,1.063ZM11.689,25.594a.531.531,0,0,1,.531-.531h4.251a.531.531,0,1,1,0,1.063H12.221A.531.531,0,0,1,11.689,25.594Zm.531,2.657a.531.531,0,1,0,0,1.063h4.251a.531.531,0,1,0,0-1.063Zm2.125,3.188a.531.531,0,1,0,0,1.063h2.125a.531.531,0,1,0,0-1.063Zm0,3.188a.531.531,0,0,0,0,1.063h2.125a.531.531,0,1,0,0-1.063Z",
    transform: "translate(0 -24)",
    fill: "#242424"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditProfileDarkIcon);
export default __webpack_public_path__ + "static/media/edit-profile-dark-icon.b5c4da6927cf065bbd6b991c4034ee39.svg";
export { ForwardRef as ReactComponent };